var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay2-right-page"},[_c('div',{staticClass:"rights-wrap"},[_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item){return _c('div',{key:item.name,staticClass:"item"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.value))])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }